<template>
  <v-dialog
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
    max-width="700px"
    min-width="360px"
  >
    <v-card v-if="curriculum_object" :loading="loading" :disabled="loading">
      <v-card-title>
        {{ $t("confirm_regis.confirm_regis") }}
      </v-card-title>
      <v-card-text :class="color">
        <div class="white--text pt-5" v-if="!available_status">
          <h2 class="font-weight-light mb-3">
            <span class="text-decoration-underline"
              >{{ $t("confirm_regis.project") }} :
              {{ objectTranslator(curriculum_object, "PROJECT_NAME") }}</span
            >
            | {{ $t("confirm_regis.round") }} :
            {{ curriculum_object.ROUND_NUMBER }} |
            {{ $t("confirm_regis.academic_year") }} :
            {{ curriculum_object.YEAR }}
          </h2>
          {{ $t("confirm_regis.alert") }}
          <v-btn x-small dense link :to="{ name: 'registered_program_list' }">{{
            $t("confirm_regis.registered_program_list")
          }}</v-btn>
        </div>
        <!-- ------------------------------------- -->
        <div class="white--text pt-5" v-if="available_status">
          <h2 class="font-weight-light mb-3">
            <span
              >{{ $t("confirm_regis.project") }} :
              {{ objectTranslator(curriculum_object, "PROJECT_NAME") }}</span
            >
            | {{ $t("confirm_regis.round") }} :
            {{ curriculum_object.ROUND_NUMBER }} |
            {{ $t("confirm_regis.academic_year") }} :
            {{ curriculum_object.YEAR }}

            <div
              v-if="
                curriculum_object.LEVEL_ID == 2 ||
                curriculum_object.LEVEL_ID == 3
              "
            >
              <span
                >{{ $t("confirm_regis.study_plan") }} :
                {{
                  objectTranslator(curriculum_object, "STUDY_PLAN_NAME")
                }}</span
              >
              |
              <span
                >{{ $t("confirm_regis.study_class") }} :
                {{
                  objectTranslator(curriculum_object, "STUDY_CLASSES_NAME")
                }}</span
              >
            </div>
          </h2>
          {{ $t("confirm_regis.fill_in_all_fields") }}
          <v-form ref="form">
            <v-row v-for="i in parseInt(number_of_rank)" :key="i">
              <v-col cols="3"> {{ $t("confirm_regis.no") }} {{ i }} </v-col>
              <v-col cols="9">
                <v-autocomplete
                  dense
                  outlined
                  filled
                  clearable
                  dark
                  v-model="selected_curriculums[i - 1]"
                  :items="available_curriculums[i - 1]"
                  :item-value="(item) => item.CURRICULUM_ID"
                  :item-text="
                    (item) =>
                      (item && item.HOT_CONSTRAINT === '1' ? '🔥 ' : '') +
                      (item && item.MASTER_REG_FACULTY_ID === '20'
                        ? '🚢 '
                        : '') +
                      objectTranslator(item, 'CURRICULUM_SHORT_NAME') +
                      (item && item.BRANCH_ID && item.BRANCH_ID !== '0'
                        ? ' ' +
                          $t('registered_program_list.branch') +
                          objectTranslator(item, 'BRANCH_NAME')
                        : '')
                  "
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
          {{ $t("confirm_regis.symbol_explanation") }}<br />
          🔥 = {{ $t("confirm_regis.icon_remark1") }} <br />
          <span v-if="has_chumporn_for_selectable"
            >🚢 = {{ $t("confirm_regis.icon_remark2") }} </span
          ><br />
          <div class="pt-5"></div>
          <div v-if="!has_chumporn">
            {{ $t("confirm_regis.remark") }}<br />
            {{ $t("confirm_regis.remark_payment_kmitl") }}<br />
          </div>
          <div v-if="has_chumporn">
            {{ $t("confirm_regis.remark") }}<br />
            <span class="yellow--text"
              >{{ $t("confirm_regis.remark_payment_ch_1") }}<br />
              {{ $t("confirm_regis.remark_payment_ch_2") }}<br />
              {{ $t("confirm_regis.remark_payment_ch_3") }}<br />
            </span>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          class="white--text"
          color="deep-purple"
          @click="regis()"
          v-if="available_status"
          :disabled="!can_regis"
          >{{ $t("confirm_regis.regis") }}</v-btn
        >
        <v-btn outlined @click="$emit('input', false)">{{
          $t("confirm_regis.close")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
import ApplicantInfoProvider from "@/services/applicant_info";
import { getById } from "@/helper/filter";
import validator from "@/helper/validator";

const applicantInfoService = new ApplicantInfoProvider();

export default {
  name: "ConfirmRegisDialog",
  props: {
    value: Boolean,
    curriculums: Array,
  },
  data: () => ({
    loading: false,

    available_status: true,

    selected_curriculums: [],
    registered_project: [],
    registered_project_ids: [],
    registered_curriculum_ids: [],
    curriculum_object: null,
    requiredRules: [validator.required],
  }),
  computed: {
    can_regis() {
      return this.selected_curriculums[0];
    },
    color() {
      return this.available_status ? "deep-purple darken-4" : "red";
    },
    number_of_rank() {
      if (!this.curriculum_object) return 0;
      return this.curriculum_object.NUMBER_OF_RANKS;
    },
    has_chumporn() {
      return this.selected_curriculums.reduce((result, item) => {
        const cur_ch_item = this.curriculums.find(
          (item_cur) => item_cur.CURRICULUM_ID === item
        );
        return (
          result || (cur_ch_item && cur_ch_item.MASTER_REG_FACULTY_ID === "20")
        );
      }, false);
    },

    has_chumporn_for_selectable() {
      const all_selectable_cur = this.curriculums.filter(
        (item) => item.PROJECT_ID === this.curriculum_object.PROJECT_ID
      );
      return all_selectable_cur.reduce(
        (result, item) => result || item.MASTER_REG_FACULTY_ID === "20",
        false
      );
    },
    available_curriculums() {
      let ret = [];
      for (let i = 0; i < this.number_of_rank; i++) {
        const other_selected = this.selected_curriculums.filter(
          (item, index) => index !== i
        );
        const other_already_has_hot = other_selected.reduce((result, item) => {
          const curr_item = getById(this.curriculums, item, "CURRICULUM_ID");
          return result || (curr_item && curr_item.HOT_CONSTRAINT);
        }, false);

        ret[i] = this.curriculums.filter(
          (item) =>
            item.PROJECT_ID === this.curriculum_object.PROJECT_ID &&
            !other_selected.includes(item.CURRICULUM_ID) &&
            !(other_already_has_hot && item.HOT_CONSTRAINT)
        );
      }
      return ret;
    },
  },
  methods: {
    objectTranslator,

    async fetchRegisteredProject() {
      const uid = localStorage.getItem("uid");
      const registered_data = await applicantInfoService.getRegisProject(uid);
      this.registered_project = registered_data;
      this.registered_project_ids = registered_data
        .filter((item) => item.REFUSED === "0")
        .map((item) => item.PROJECT_ID);
      this.registered_curriculum_ids = registered_data
        .filter((item) => item.REFUSED === "0")
        .map((item) => item.register_curriculum[0]?.ADMISSION_CURRICULUM_ID);
    },

    async prepareDataBeforeOpenDialog(curriculum_object) {
      if (this.$refs.form) await this.$refs.form.reset();
      if (curriculum_object.LEVEL_ID == 1) {
        this.available_status = !this.registered_project_ids.includes(
          curriculum_object.PROJECT_ID
        );
      }
      if (curriculum_object.LEVEL_ID == 2 || curriculum_object.LEVEL_ID == 3) {
        this.available_status = !this.registered_curriculum_ids.includes(
          curriculum_object.CURRICULUM_ID
        );
      }
      this.selected_curriculums = [];
      this.curriculum_object = curriculum_object;
      this.selected_curriculums.push(curriculum_object.CURRICULUM_ID);
    },

    async regis() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        const curiculum_ids = this.selected_curriculums
          .filter((item) => item)
          .map((item, index) => ({
            CURRICULUM_ID: item,
            ORDER: index + 1,
          }));
        const uid = localStorage.getItem("uid");
        const response = await applicantInfoService
          .regisCurriculum(this.curriculum_object.PROJECT_ID, curiculum_ids, uid)
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.loading = false;
          });
        if (response && response.status) {
          await this.$store.dispatch("auth/getSidebarStatus");
          this.$toasted.success("regis successful", { duration: 0 });
          this.$router.push({ name: "registered_program_list" });
          this.loading = false;
        }
      }
    },
  },

  created() {
    this.fetchRegisteredProject();
  },
};
</script>
